import React, { Component } from 'react';
import { Provider } from 'react-redux';
import deepMerge from 'lodash-es/merge';
import ReservationPage from '../../page/ReservationPage';
import store from '../../configureStore';
import * as settingsActions from '../../actions/settings';

export default class ReservationWidgetContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: null,
    };
  }

  componentDidMount() {
    if (window.xprops) {
      if (window.xprops.onTrigger) window.xprops.onTrigger('resize', 60);
      this.setup();
    } else {
      const intervalId = setInterval(this.setup.bind(this), 200);
      this.setState({ intervalId });
    }
  }

  componentWillUnmount() {
    const { intervalId } = this.state;
    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  setup() {
    const { xprops } = window;
    if (xprops) {
      if (this._setupDone) return;
      this._setupDone = true;
      const {
        defaultSetting,
        defaultTranslation,
        exceededBookingsLimit,
        exceededTrialPlan,
        securityBondExternalId,
      } = this.props;
      let { settings } = this.props;
      const { intervalId } = this.state;

      const newStyle = xprops.data && xprops.data.style;

      if (newStyle) settings = deepMerge(settings, { style: newStyle });

      store.dispatch(
        settingsActions.setConfiguration({
          ...settings,
          defaultSetting,
          defaultTranslation,
          exceededBookingsLimit,
          exceededTrialPlan,
          securityBondExternalId,
        }),
      );

      if (xprops && xprops.onInit) xprops.onInit(settings.setting);

      clearInterval(intervalId);
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <ReservationPage {...this.props} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting({ key, value }));
